<script lang="ts">
    import type {UserAccountReactivePageData, UserAccountStaticPageData} from '../types';
    import {getPageContext} from 'shared/layouts/page-context';
    import KpSdiRequestsPanel from '../../../sdi-requests/kp-sdi-requests/KpSdiRequestsPanel.svelte';

    const pageContext = getPageContext<UserAccountStaticPageData, UserAccountReactivePageData>();
    const user = pageContext.staticData.user;
</script>

<div class="kp-user-sdi-requests-panel-part">
    <KpSdiRequestsPanel {user}/>
</div>